export default __webpack_public_path__ + "static/media/product06-1-480x360.02788e3a.jpg";